const BASE_STYLE = 'rounded-sm bg-gradient-to-b p-2';

export const COLORS = [
  `${BASE_STYLE} from-yellow-200 to-yellow-400 text-yellow-800 dark:from-yellow-200 dark:to-yellow-600`,
  `${BASE_STYLE} from-orange-200 to-orange-400 text-orange-800 dark:from-orange-200 dark:to-orange-600`,
  `${BASE_STYLE} from-red-200 to-red-400 text-red-800 dark:from-red-200 dark:to-red-600`,
  `${BASE_STYLE} from-green-200 to-green-400 text-green-800 dark:from-green-200 dark:to-green-600`,
  `${BASE_STYLE} from-blue-200 to-blue-400 text-blue-800 dark:from-blue-200 dark:to-blue-600`,
  `${BASE_STYLE} from-purple-200 to-purple-400 text-purple-800 dark:from-purple-200 dark:to-purple-600`,
  `${BASE_STYLE} from-pink-200 to-pink-400 text-pink-800 dark:from-pink-200 dark:to-pink-600`,
  `${BASE_STYLE} from-gray-200 to-gray-400 text-gray-800 dark:from-gray-200 dark:to-gray-600`,
  `${BASE_STYLE} from-sky-200 to-sky-400 text-sky-800 dark:from-sky-200 dark:to-sky-600`,
  `${BASE_STYLE} from-indigo-200 to-indigo-400 text-indigo-800 dark:from-indigo-200 dark:to-indigo-600`,
  `${BASE_STYLE} from-amber-200 to-amber-400 text-amber-800 dark:from-amber-200 dark:to-amber-600`,
  `${BASE_STYLE} from-teal-200 to-teal-400 text-teal-800 dark:from-teal-200 dark:to-teal-600`,
  `${BASE_STYLE} from-cyan-200 to-cyan-400 text-cyan-800 dark:from-cyan-200 dark:to-cyan-600`,
  `${BASE_STYLE} from-lime-200 to-lime-400 text-lime-800 dark:from-lime-200 dark:to-lime-600`,
  `${BASE_STYLE} from-emerald-200 to-emerald-400 text-emerald-800 dark:from-emerald-200 dark:to-emerald-600`,
] as const;
